import { render } from "./phonePrefix.vue?vue&type=template&id=2ecd910f&scoped=true&ts=true"
import script from "./phonePrefix.vue?vue&type=script&lang=ts"
export * from "./phonePrefix.vue?vue&type=script&lang=ts"

import "./phonePrefix.vue?vue&type=style&index=0&id=2ecd910f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ecd910f"]])

export default __exports__